import { param, deparam } from 'utils/Param.js'

const history = {
  /**
   * [get url params as object]
   */
  get: () => {
    /* grab existing params */
    let initial = window.location.search
    /* remove leading ? */
    while (initial.charAt(0) === '?') {
      initial = initial.substr(1)
    }
    /* convert to object and merge with argument params */
    return deparam(initial)
  },
  /**
   * [set url params to an object retaining exisitng params]
   */
  set: (params, replace = false, customPath) => {
    if (!window.history.replaceState) return false
    /* grab existing params */
    let initial = window.location.search
    /* remove leading ? */
    while (initial.charAt(0) === '?') {
      initial = initial.substr(1)
    }
    /* convert to object and merge with argument params */
    const qp = replace ? { ...params } : { ...deparam(initial), ...params }
    /* write to history */
    const url = `${window.location.protocol}//${window.location.host}${
      customPath ? customPath : window.location.pathname
    }${param(qp) && '?'}${param(qp)}`

    window.history.replaceState(
      {
        path: url,
      },
      '',
      url
    )
  },
}

export default history
